import { render, staticRenderFns } from "./unloading.vue?vue&type=template&id=2ed2aeec&scoped=true"
import script from "./unloading.vue?vue&type=script&lang=js"
export * from "./unloading.vue?vue&type=script&lang=js"
import style0 from "./unloading.vue?vue&type=style&index=0&id=2ed2aeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2aeec",
  null
  
)

export default component.exports